import { render, staticRenderFns } from "./CommissionsChart.vue?vue&type=template&id=02287b36"
import script from "./CommissionsChart.vue?vue&type=script&lang=js"
export * from "./CommissionsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports